// src/components/web/Header/LanguageSelector.jsx
import React from "react";
import { Box, Button, Menu, MenuItem } from "@mui/material";
import { useTranslation } from "@/hooks/useTranslation";
import Icon from "@/theme/vectors/bundle";

const LanguageSelector = () => {
    const { t, language, changeLanguage } = useTranslation();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLanguageChange = (lang) => {
        changeLanguage(lang);
        handleClose();
    };

    return (
        <Box>
            <Button
                onClick={handleClick}
                sx={{
                    minWidth: "auto",
                    color: "primary.main",
                    textTransform: "none",
                    fontWeight: "medium",
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                }}
            >
                {language === "vi" ? "VI" : "EN"}
                <Icon name="downChevron" size={12} />
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
            >
                <MenuItem
                    onClick={() => handleLanguageChange("vi")}
                    selected={language === "vi"}
                >
                    {t("common.vietnamese")}
                </MenuItem>
                <MenuItem
                    onClick={() => handleLanguageChange("en")}
                    selected={language === "en"}
                >
                    {t("common.english")}
                </MenuItem>
            </Menu>
        </Box>
    );
};

export default LanguageSelector;
